"use client";
import { LandingPageDocument, type LandingPageQuery } from "@/generated/client.generated";
import { useQuery } from "@apollo/client";

//use this hook if retrieving page data from cms in a client component
//if react server component(Does not have "use client") use server-functions/GetPage.tsx instead
export const UsePage = (path: string) => {
  const page = useQuery<LandingPageQuery>(LandingPageDocument, { variables: { path: path } }).data;
  if (page) {
    return page.LandingPage;
  }
  return null;
};
